import { Emitter, Event } from "../../../../features/event-emitter"
import { Data, ModalId, O, showToast, useUIActions } from "../../../../features/ui"
import { Branch } from "../../../manager"
import { Company, useSystemActions } from "../../../system"
import { define } from "../../../../utils/typeUtils"
import { useNavigate } from "react-router-dom"
import { RoutePath, useRoutesHooks } from "../../../../features/routes"
import { useAddressBuilders } from "../../../../features/address"

export const useActions = () => {
    const navigate = useNavigate()
    const { getRoutePath } = useRoutesHooks()

    const { buildAddress } = useAddressBuilders()

    const systemActions = useSystemActions()
    const { closeModal } = useUIActions()

    const onBranchClick = (branch: Branch) => () => {
        navigate(getRoutePath(RoutePath.BRANCHES, branch.id))
    }

    const updateCompany = (
        company: Company,
        companyData: Data,
        addressData: Data,
        taxIdsData: Company['taxIds'],
        logoFile?: File
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const { legalName, websiteUrl, email, phone, grossIncomeCode } = companyData
        const address = buildAddress(addressData)
        const updatedCompany: Company = {
            ...company,
            legalName: define(legalName) as string,
            taxIds: taxIdsData,
            websiteUrl: define(websiteUrl) as string,
            email: define(email) as string,
            address,
            phone: phone as O<number>,
            grossIncomeCode: grossIncomeCode as O<number>
        }

        systemActions().saveCompany(updatedCompany, logoFile).then(() => {
            closeModal(ModalId.SPINNER)
            showToast('Se actualizó la información de la compañía.')
        })
    }
    
    return {
        onBranchClick,
        updateCompany
    }
}
